import axios from "utils/axios";
import { API_BASE_URL, API_PLAN } from "utils/constants";

export interface PlanCreateSessionResponse {
  session: string;
  environment: string;
}
export interface PlanCustomerPortalResponse {
  redirectURL: string;
}

const createSession = () =>
  axios.get(
    `${API_BASE_URL}${API_PLAN.BASE_URL}${API_PLAN.CREATE_SESSION_URL}`
  );
const getCustomerPortalURL = () =>
  axios.get(
    `${API_BASE_URL}${API_PLAN.BASE_URL}${API_PLAN.GET_CUSTOMER_PORTAL_URL}`
  );

const planAPI = {
  createSession,
  getCustomerPortalURL,
};

export default planAPI;
